import { render, staticRenderFns } from "./member-card.vue?vue&type=template&id=618fbdad&scoped=true"
import script from "./member-card.vue?vue&type=script&lang=ts"
export * from "./member-card.vue?vue&type=script&lang=ts"
import style0 from "./member-card.vue?vue&type=style&index=0&id=618fbdad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618fbdad",
  null
  
)

export default component.exports